import * as React from 'react';

const InfoCircle24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 3a.75.75 0 0 0-.75.75v5.5a.75.75 0 0 0 1.5 0v-5.5A.75.75 0 0 0 12 10"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m0-1.5a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19"
  }
));
InfoCircle24.Size = 24;
InfoCircle24.Title = "InfoCircle";

export { InfoCircle24 as default };
